package com.anjuros.website.templates.template1.modules

import com.anjuros.website.templates.template1.util.ResKey

enum class Template1Section(
    val id:String,
    val title:ResKey?,
    val path:String
) {

    Service(
        id = "service",
        title = ResKey.TEMPLATE1_SECTION1,
        path = "#service"
    ),
    Testimonial(
        id = "reviews",
        title = ResKey.TEMPLATE1_SECTION2,
        path = "#reviews"
    ),
    Prices(
        id = "prices",
        title = ResKey.TEMPLATE1_SECTION3,
        path = "#prices"
    ),
    Contact(
        id = "contact",
        title = ResKey.TEMPLATE1_SECTION4,
        path = "#contact"
    )
}